import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=a55493ac&scoped=true&"
import script from "./customers.vue?vue&type=script&lang=ts&"
export * from "./customers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55493ac",
  null
  
)

export default component.exports